import { STORE_TEMP_GRAPHIC } from '../../constants/appTypes';

const initialState: __esri.Graphic | null = null;

interface storeTempGraphicAction {
  graphic: __esri.Graphic;
  type: string;
}

export function tempGraphic(state = initialState, action: storeTempGraphicAction) {
  switch (action.type) {
    case STORE_TEMP_GRAPHIC:
      state = action.graphic;
      return state;
    default:
      return state;
  }
}

export default tempGraphic;
